module.exports = __webpack_public_path__ + "img/template-union.3329f886.svg";